import React, { useState } from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import axios from "axios";
import { connect } from "react-redux";
import { Alert, CircularProgress } from "@mui/material";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import OpenDocument from "helpers/openDocument";
import secureLocalStorage from "react-secure-storage";

const passwordRegExp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
const validatePassword = (val) =>
  "Password must be at least 8 characters long and contain both letters and numbers.";

function ResetPassword(props) {
  const { token } = useParams();
  const { errorMessage, successMessage } = props;
  const [value, setValue] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showStates, setShowStates] = useState({
    newPassword: false,
    confirmPassword: false,
  });

  const settings = secureLocalStorage.getItem("systemSettings");
  const systemSettings = JSON.parse(settings);
  const backgroundColor = systemSettings?.mainBackground ?? "bg-blueGray-800";
    const history = useHistory();

  const setValue0 = (field, val) => {
    setValue((prev) => ({ ...prev, [field]: val }));
  };

  const toggleShow = (field) => {
    setShowStates((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const fields = [
    {
      name: "newPassword",
      label: "New Password",
      type: "password",
      required: true,
      value: value["newPassword"],
      validate: (val) =>
        passwordRegExp.test(val) ? undefined : validatePassword(val),
      setValue: (v) => setValue0("newPassword", v),
      icon: require("../../assets/img/password.svg").default,
    },
    {
      name: "confirmPassword",
      label: "Confirm New Password",
      type: "password",
      required: true,
      value: value["confirmPassword"],
      setValue: (v) => setValue0("confirmPassword", v),
      validate: (val) =>
        val === value["newPassword"]
          ? undefined
          : "Password Confirmation Mismatch",
      icon: require("../../assets/img/password.svg").default,
    },
  ];

  const handleReset = async (e) => {
    e.preventDefault();
    if (loading) return;

    const newErrors = {};
    fields.forEach((field) => {
      const error = field.validate?.(field.value);
      if (error) newErrors[field.name] = error;
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    setErrors({});
    try {
      const res = await axios.post("/api/user/reset-password", {
        token,
        newPassword: value["newPassword"],
      });
      setMessage(res.data.message);
    } catch (err) {
      setMessage("Error resetting password Token expired ");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="overflow-hidden">
      <div className="relative flex items-center justify-center w-full h-full">
        <div className="relative container mx-auto px-0 h-full">
          <div className="flex flex-col content-center items-center justify-center h-full">
            <div className="rounded-t mb-0 px-6 py-6">
              <div className="text-center">
                {/* <img src={ifLogoWhite} alt="IF Logo" className="h-16 w-auto" /> */}
                <OpenDocument
                  mimeType={"image"}
                  document={systemSettings?.logoImage}
                  downloadable={false}
                  type={"logo"}
                  imgClassName="h-16 w-auto"
                />
              </div>
            </div>
            <div className="w-full lg:w-4/12 px-4">
              <div className="bg-white rounded-lg shadow-lg p-6">
                {(errorMessage || successMessage) && (
                  <Alert
                    className="mb-3"
                    severity={successMessage ? "success" : "error"}
                  >
                    {successMessage ?? errorMessage}
                  </Alert>
                )}

                <form onSubmit={handleReset}>
                  <h2 className="text-2xl font-bold mb-4">Reset Password</h2>

                  {message && (
                    <div className="mb-4 text-sm text-pink-600">{message}</div>
                  )}

                  {fields.map((field) => (
                    <div className="relative w-full mb-3" key={field.name}>
                      <label className="text-black text-sm mb-2">
                        {field.label}
                      </label>
                      <div className="relative flex items-center mt-1">
                        <input
                          type={showStates[field.name] ? "text" : "password"}
                          required={field.required}
                          value={field.value}
                          onChange={(e) => field.setValue(e.target.value)}
                          className="border border-input px-3 py-3 pl-10 pr-10 placeholder-blueGray-300 text-black bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          placeholder="********"
                        />
                        <img
                          src={field.icon}
                          alt="Password Icon"
                          className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500"
                        />
                        <i
                          className={`far ${
                            showStates[field.name] ? "fa-eye" : "fa-eye-slash"
                          } absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500`}
                          onClick={() => toggleShow(field.name)}
                        ></i>
                      </div>
                      {errors[field.name] && (
                        <p className="text-sm text-red-500 mt-1">
                          {errors[field.name]}
                        </p>
                      )}
                    </div>
                  ))}

                                    {message === "Password reset successfully" ? (
                                        <>
                                            <div className="text-center mt-3">
                                                <button
                                                    type="button"
                                                    className={`flex justify-center text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150 bg-primary`}
                                                    onClick={() => history.push("/auth/login")}
                                                >
                                                    Go to Login
                                                </button>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="text-center mt-3">
                                            <button
                                                className={`flex justify-center text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150 bg-primary`}
                                                type="submit"
                                            >
                                                Reset Password
                                                {loading && (
                                                    <CircularProgress size={20} className="ml-3 text-white" />
                                                )}
                                            </button>
                                        </div>
                                    )}
                                </form>

                <div className="mt-3 text-center">
                  <span className="text-gray-500 text-sm">Can't access? </span>
                  <a
                    href="https://www.qtglobal.rw/contact"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 text-sm"
                  >
                    Contact Admin
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
